import { render, staticRenderFns } from "./ContractView.vue?vue&type=template&id=22ec28f6&scoped=true&"
import script from "./ContractView.vue?vue&type=script&lang=js&"
export * from "./ContractView.vue?vue&type=script&lang=js&"
import style0 from "./ContractView.vue?vue&type=style&index=0&id=22ec28f6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec28f6",
  null
  
)

export default component.exports